import { createFileRoute } from '@tanstack/react-router'
import { DeliveryScreen } from '../features/delivery/DeliveryScreen'

interface DeliverySearch {
  readonly submissionId?: string
}

function Delivery() {
  const { workspaceId } = Route.useParams()
  const { submissionId } = Route.useSearch()
  return (
    <DeliveryScreen
      workspaceId={workspaceId}
      {...(submissionId === undefined ? {} : { submissionId })}
    />
  )
}

export const Route = createFileRoute('/w/$workspaceId/delivery')({
  component: Delivery,
  validateSearch: (search: Record<string, unknown>): DeliverySearch =>
    typeof search.submissionId === 'string' && search.submissionId.trim() !== ''
      ? { submissionId: search.submissionId }
      : {},
})
